import { useState } from 'react'

export const useManualMode = () => {
  const [isManualMode, setIsManualMode] = useState(false)
  const [manualModeBySlide, setManualModeBySlide] = useState<Record<number, boolean>>({})

  const enableManualMode = (slideIndex: number) => {
    setIsManualMode(true)
    setManualModeBySlide(prev => ({
      ...prev,
      [slideIndex]: true,
    }))
  }

  const enableManualModeForAllSlides = (totalSlides: number) => {
    const allSlidesManual = Object.fromEntries(
      Array.from({ length: totalSlides }, (_, slideIndex) => [slideIndex, true]),
    )
    setManualModeBySlide(allSlidesManual)
    setIsManualMode(true)
  }

  const setManualModeForSlide = (slideIndex: number, shouldUpdateGlobal: boolean = false) => {
    const slideHasManualMode = manualModeBySlide[slideIndex] || false
    setIsManualMode(slideHasManualMode)

    if (shouldUpdateGlobal) {
      setManualModeBySlide(prev => ({
        ...prev,
        [slideIndex]: true,
      }))
    }
  }

  return {
    isManualMode,
    manualModeBySlide,
    enableManualMode,
    enableManualModeForAllSlides,
    setManualModeForSlide,
  }
}
